import { render, staticRenderFns } from "./buyInfo.vue?vue&type=template&id=d6d69028&scoped=true&lang=html&"
import script from "./buyInfo.vue?vue&type=script&lang=js&"
export * from "./buyInfo.vue?vue&type=script&lang=js&"
import style0 from "./buyInfo.vue?vue&type=style&index=0&id=d6d69028&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d69028",
  null
  
)

export default component.exports